import Analytics from "analytics";
import segmentPlugin from "@analytics/segment";

// The @analytics/segment plugin injects a <script id="segment-io"> tag but never
// sets onerror on it. When ad blockers or network issues block cdn.segment.com,
// the browser fires onerror with no handler and it surfaces as an unhandled error.
// Observe the DOM for that script tag and silently handle the failure.
const observer = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.id === "segment-io") {
        node.onerror = () => {};
        observer.disconnect();
        return;
      }
    }
  }
});
observer.observe(document.head || document.documentElement, { childList: true, subtree: true });

/* Initialize analytics & load plugins */
export const analytics = Analytics({
  app: "dropshipper-app",
  plugins: [
    segmentPlugin({
      writeKey: process.env.REACT_APP_SEGMENT_ANALYTICS,
      debug: process.env.NODE_ENV === "development"
    })
  ]
});
